export default "__VITE_ASSET__BzltoTKQ__"